import { AnimatePresence, motion } from 'framer-motion'
import {
  HiCheckCircle,
  HiExclamationTriangle,
  HiInformationCircle,
  HiXCircle,
  HiXMark,
} from 'react-icons/hi2'
import { useToastStore, type ToastVariant } from '@/store/toast'
import { cn } from '@/utils/cn'

const meta: Record<ToastVariant, { icon: JSX.Element; ring: string; iconColor: string }> = {
  success: { icon: <HiCheckCircle />, ring: 'border-l-success', iconColor: 'text-success' },
  error: { icon: <HiXCircle />, ring: 'border-l-danger', iconColor: 'text-danger' },
  warning: { icon: <HiExclamationTriangle />, ring: 'border-l-warning', iconColor: 'text-warning' },
  info: { icon: <HiInformationCircle />, ring: 'border-l-primary', iconColor: 'text-primary' },
}

export function Toaster() {
  const { toasts, dismiss } = useToastStore()
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[1400] flex w-full max-w-sm flex-col gap-2">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.id}
            layout
            initial={{ opacity: 0, x: 60, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 60, scale: 0.9 }}
            transition={{ type: 'spring', damping: 24, stiffness: 300 }}
            className={cn(
              'pointer-events-auto flex items-start gap-3 rounded-xl border border-l-4 border-border bg-card p-4 shadow-elevated',
              meta[t.variant].ring,
            )}
          >
            <span className={cn('mt-0.5 text-xl', meta[t.variant].iconColor)}>{meta[t.variant].icon}</span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-foreground">{t.title}</p>
              {t.description && <p className="mt-0.5 text-sm text-muted-foreground">{t.description}</p>}
            </div>
            <button
              onClick={() => dismiss(t.id)}
              className="rounded p-1 text-muted-foreground hover:bg-muted"
              aria-label="Dismiss"
            >
              <HiXMark className="h-4 w-4" />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  )
}
